export const configStripShopPasteTooltipLocale = $localize`:Config Strip|Paste tooltip message@@pasteTooltipMessage:This will copy all quantities from the currently active shop to any other in between.`;
